import React from 'react';
import { Link } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';

import './styles.css';

const Breadcrumbs = (props) => {
    return (
        <div className="breadcrumb-analysis">
            <div className="container">
                <Breadcrumb>
                    <BreadcrumbItem><Link to='/'>DMV Imóveis</Link></BreadcrumbItem>                    
                    <BreadcrumbItem active>Cadastre seu imóvel</BreadcrumbItem>
                </Breadcrumb>
            </div>
        </div>
    );
};

export default Breadcrumbs;